import {clearHours} from '../util';

export default {
  name: 'PanelTable',
  props: {
    tableDate: {
      type: Date,
      required: true
    },
    disabledDate: {
      type: Function
    },
    selectionMode: {
      type: String,
      required: true
    },
    value: {
      type: Array,
      required: true
    },
    rangeState: {
      type: Object,
      default: () => ({
        from: null,
        to: null,
        selecting: false
      })
    },
    comparedRange: {
      type: Object,
      default: () => ({})
    },
    publicStringValue: {
      type: Array,
      default: () => [null, null]
    },
    isCompared: {
      type: Boolean,
      default: false
    },
    focusedDate: {
      type: Date,
      required: true,
    }
  },
  computed: {
    dates() {
      const {selectionMode, value, rangeState, comparedRange, publicStringValue} = this;
      const rangeSelecting = selectionMode === 'range' && rangeState.selecting;
      const comparedSelecting = selectionMode === 'range' && comparedRange.selecting;
      if (this.isCompared) {
        return comparedSelecting ? [comparedRange.from]
          : this.comparedRange.to ? [new Date(this.comparedRange.from), new Date(this.comparedRange.to)]
            : value;
      }
      else return rangeSelecting ? [rangeState.from] : publicStringValue.map(str => new Date(str));
    },
  },
  methods: {
    handleClick(cell) {
      if (cell.disabled || cell.type === 'weekLabel') return;
      const newDate = new Date(clearHours(cell.date));

      this.$emit('on-pick', newDate);
      this.$emit('on-pick-click');
    },
    handleMouseMove(cell) {
      let notSelecting = !this.isCompared ? !this.rangeState.selecting : !this.comparedRange.selecting;
      if (notSelecting) return;
      if (cell.disabled) return;
      const newDate = cell.date;
      this.$emit('on-change-range', newDate);
    },
  }
};



// WEBPACK FOOTER //
// ./src/views/my-components/custom-date-picker/base/mixin.js